import {
  ExternalBankAccount,
  ExternalBankAccountStatus,
  PaymentMethodCapability
} from "@wingspanhq/wingspan-api-sdk";

export const selectorExternalBankAccountPayoutReady = (
  externalBankAccount: ExternalBankAccount
) =>
  !!externalBankAccount.capabilities?.includes(
    PaymentMethodCapability.PAYOUT
  ) &&
  externalBankAccount.status !== ExternalBankAccountStatus.REMOVED &&
  externalBankAccount.status !== ExternalBankAccountStatus.FAILED;
